/* eslint-disable @next/next/no-img-element */
import { FC, useCallback, useState } from 'react'
import { ImgBackground } from 'components/basic/Img'
import { AnimateOnReveal } from 'components/AnimateOnScroll'
import styles from './Parallax.module.scss'
import { Waypoint } from 'react-waypoint'

export const Parallax: FC = () => {
	const [entered, setEntered] = useState(false)

	const handleEnter = useCallback(() => {
		setEntered(true)
	}, [])

	return (
		<ImgBackground
			sources={[
				{
					mediaQuery: '(max-width: 599px)',
					src: 'https://eight-eightsleep-react.s3.us-east-2.amazonaws.com/assets/athletes-efcycling-mobile.jpg',
				},
				{
					mediaQuery: '(min-width: 600px)',
					src: 'https://eight-eightsleep-react.s3.us-east-2.amazonaws.com/assets/athletes-efcycling-desktop.jpg',
				},
			]}
			src="https://eight-eightsleep-react.s3.us-east-2.amazonaws.com/assets/athletes-efcycling-desktop.jpg"
			alt=""
			className={`${styles.container} ${entered ? styles.entered : ''}`}
		>
			<AnimateOnReveal noMinHeight>
				<Waypoint
					onEnter={handleEnter}
					scrollableAncestor={'window'}
				>
					<div></div>
				</Waypoint>
				<h3 className={styles.heading}>Official Sleep Fitness Partner</h3>
				<p className={styles.subline}>Powering one of the most successful cycling team in the world all year round, including at the Tour de France.</p>
				<div className={styles.logos}>
					<div>
						<img
							src="https://eight-eightsleep-react.s3.us-east-2.amazonaws.com/assets/ef-procycling-easypost.png"
							alt="EF Pro Cycling partner logos"
						/>
					</div>
					<div>
						<img
							src="https://eight-eightsleep-react.s3.us-east-2.amazonaws.com/assets/ef-tibco-svb-logos.png"
							alt="EF TIBCO SVB logos"
						/>
					</div>
				</div>
			</AnimateOnReveal>
		</ImgBackground>
	)
}
